module.exports = __webpack_public_path__ + "static/media/hero_getty.ba956672.jpg";